import React from 'react'
import { useState, useEffect } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import "./index.css";
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchStudent_Enrollment_Report, fetchStudent_Characteristics, fetchStudent_Group, fetchStudent_Enrollment_By_Year,
  fetchStudent_Enrollment_By_Grade, fetchSchool_And_Centers, fetchSchools_Centers_Report, fetchAt_A_Glance_Top_Tile,
  fetchTeacherFTE,
  fetchTotalTeacherFTE,
  fetchStudentCounselorRatio,
  fetchStudentTeacherRatio
} from '../../redux/slices/counter';
import { Dropdown } from 'primereact/dropdown';

import {
  fetchEnrollment, fetchSpecial_Group, fetchEthnicity_Mix, fetchSPED_Enrollment, fetchNet_Movement, fetchGraduation_To_KG_Enrollment_Ratio,
  fetchInter_School_Conversion, fetchSchools_Biggest_Gainers, fetchSchools_Biggest_Losers, fetchTime_Analysis, fetchEnrollment_Time_Analysis,
  fetchEnrollment_Summary_By_Dimensions
} from '../../redux/slices/enrollment';

import {
  fetchDistrict_Climate_Rating, fetchstudent_behavior_poor_performing_schools, fetchstudent_behavior_top_performing_schools,
  fetchStudent_Behavior_Incident_Type, fetchStudent_Behavior_Chart
} from '../../redux/slices/studentbehavior';

import {
  fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART, fetchImprovement_Tile_Report, fetchStrength_Tile_Report, fetchWeakness_Tile_Report,
  fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART_GRADUATION
} from '../../redux/slices/strengthweakness';

import {
  fetchstudent_performance_tile_report, fetchstudent_dimension_table_report, fetchstudent_dimension_report,
  fetchstudent_dimension_table_report_graduation,
  fetchstudent_dimension_report_graduation
} from '../../redux/slices/studentperformance';

import {
  fetchSchool_Performance_School_Type_Report, fetchSchool_Performance_Metric_Report,
  fetchSchool_Performance_Map_Report, fetchSchool_Performance_Pie_Chart_Report
} from '../../redux/slices/schoolperformance';
import { fetchMenu_School_Year, fetchMenu_School_Level, fetchMenu_School_Name, fetchMenu_Gender, fetchMenu_Grade, fetchMenu_Ethnicity } from '../../redux/slices/filter';
import { fetchCost_Per_Student, fetchDemographic, fetchDistrict_Size, fetchFunding, fetchNearby_District } from '../../redux/slices/statebenchmarking';


function FilterComponent() {
  var pagename = window.location.pathname;
  // const yearOptions=[
  //     {name:"2023",value:"2023"},
  //     {name:"2022",value:"2022"},
  //     {name:"2021",value:"2021"},
  //     {name:"2020",value:"2020"},
  //     {name:"2019",value:"2019"},
  // ]
  // let schoolTypeOptions=[
  //     {label:"High School",value:"High School"},
  //     {label:"Middle School",value:"Middle School"},
  //     {label:"Elementory School",value:"Elementory School"},
  //     {label:"Not Reported",value:"Not Reported"},
  //     {label:"Other Combination",value:"Other Combination"},
  // ]

  // let genderOptions=[
  //     {label:"Male",value:"Male"},
  //     {label:"Female",value:"Female"},
  //     {label:"Others",value:"Others"}
  // ]

  // let ethinOption=[
  //     {label:"Hispanic",value:"Hispanic"},
  //     {label:"Not Reported",value:"Not Reported"},
  //     {label:"Multi-racial",value:"Multi-racial"},
  //     {label:"Black Non-Hispanic",value:"Black Non-Hispanic"},
  //     {label:"White Non-Hispanic",value:"White Non-Hispanic"},
  //     {label:"Asian or pasific Islander",value:"Asian or pasific Islander"},
  //     {label:"Amer Indian or Alaskan Native",value:"Amer Indian or Alaskan Native"}
  // ]

  // let gradeOptions=[
  //     {label:"Preschool/Prekindergarten",value:"Preschool/Prekindergarten"},
  //     {label:"KinderGarten",value:"KinderGarten"},
  //     {label:"First Grade",value:"First Grade"},
  //     {label:"Second Grade",value:"Second Grade"},
  //     {label:"Third Grade",value:"Third Grade"},
  //     {label:"Fourth Grade",value:"Fourth Grade"},
  //     {label:"Fifth Grade",value:"Fifth Grade"},
  //     {label:"Sixth Grade",value:"Sixth Grade"},
  //     {label:"Seventh Grade",value:"Seventh Grade"},
  //     {label:"Eighth Grade",value:"Eighth Grade"},
  //     {label:"Ninth Grade",value:"Ninth Grade"},
  //     {label:"Tenth Grade",value:"Tenth Grade"},
  //     {label:"Eleventh Grade",value:"Eleventh Grade"},
  //     {label:"Twelfth Grade",value:"Twelfth Grade"},
  //     {label:"Early Education",value:"Early Education"}
  // ]

  const Menu_School_Yeardata = useSelector(state => state.filter.Menu_School_Year);
  const Menu_School_Leveldata = useSelector(state => state.filter.Menu_School_Level);
  const Menu_School_Namedata = useSelector(state => state.filter.Menu_School_Name);
  const Menu_Gender = useSelector(state => state.filter.Menu_Gender);
  const Menu_Grade = useSelector(state => state.filter.Menu_Grade);
  const Menu_Ethnicity = useSelector(state => state.filter.Menu_Ethnicity);



  const [selectedMenu_School_Year, setselectedMenu_School_Year] = useState(Menu_School_Yeardata)
  const [selectedMenu_School_Level, setSelectedMenu_School_Level] = useState(Menu_School_Leveldata)
  const [selectedMenu_School_Name, setSelectedMenu_School_Name] = useState(Menu_School_Namedata)
  const [selectedMenu_Gender, setSelectedMenu_Gender] = useState(Menu_Gender)
  const [selectedMenu_Grade, setSelectedMenu_Grade] = useState(Menu_Grade)
  const [selectedMenu_Ethnicity, setSelectedMenu_Ethnicity] = useState(Menu_Ethnicity)

  var yearOptions = [];
  selectedMenu_School_Year?.forEach(year => {
    const yearValue = year.SCHOOL_YEAR?.toString();

    // Exclude 2024 and 2025 only if pathname is "/statebenchmarking"
    if (pagename === "/statebenchmarking" && (yearValue === "2025")) {
      return;
    }

    yearOptions.push({ name: yearValue, value: yearValue });
  });
  // console.log("yearOptions",yearOptions)

  var schoolTypeOptions = [];
  selectedMenu_School_Level?.forEach(year => {
    schoolTypeOptions.push({ 'label': year.SCHOOL_TYPE, 'value': year.SCHOOL_TYPE })
  })
  // console.log("schoolTypeOptions",schoolTypeOptions)


  var genderOptions = [];
  selectedMenu_Gender?.forEach(year => {
    genderOptions.push({ 'label': year.GENDER, 'value': year.GENDER })
  })


  var gradeOptions = [];
  selectedMenu_Grade?.forEach(year => {
    gradeOptions.push({ 'label': year.GRADE, 'value': year.GRADE })
  })

  var ethinOption = [];
  selectedMenu_Ethnicity?.forEach(year => {
    ethinOption.push({ 'label': year.ETHNICITY, 'value': year.ETHNICITY })
  })

  var schoolnameOption = [];
  selectedMenu_School_Name?.forEach(year => {
    schoolnameOption.push({ 'label': year.SCHOOL_NAME, 'value': year.SCHOOL_NAME })
  })

  const dispatch = useDispatch();

  const [selectedYearreset, setSelectedYearreset] = useState({
    "columnName": "SCHOOL_YEAR",
    "columnValue": "2025",
    "excludeKeyword": false
  })
  const [selectedSchoolreset, setSelectedSchoolreset] = useState({
    "columnName": "SCHOOL_TYPE",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGenderreset, setSelectedGenderreset] = useState({
    "columnName": "STUDENT_GENDER",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedEthincityreset, setSelectedEthincityreset] = useState({
    "columnName": "STUDENT_ETHNICITY",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGradereset, setSelectedGradereset] = useState({
    "columnName": "STUDENT_GRADE",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedschoolnamereset, setSelectedschoolnamereset] = useState({
    "columnName": "SCHOOL_OFFICIAL_NAME",
    "columnValue": [],
    "excludeKeyword": false
  })

  const resetFilterFunc = () => {
    // window.sessionStorage.removeItem('allfilter');
    setSelectedYeardata("2025")
    setSelectedSchooldata([])
    setSelectedGenderdata([])
    setSelectedEthincitydata([])
    setSelectedGradedata([])
    setSelectedSchoolnamedata([])

    const body = {
      "elasticQueryName": "",
      "filters":
        removeNullFun1()
      ,
      "grad_filters":
        removeNullFunGrad1()
      ,
      "dynamicColumns": [],
    };
    handleChange(body)
  }

  const removeNullFun1 = () => {
    let j = [
      selectedYearreset.columnValue.length && selectedYearreset,
      selectedSchoolreset.columnValue.length && selectedSchoolreset,
      selectedGenderreset.columnValue.length && selectedGenderreset,
      selectedEthincityreset.columnValue.length && selectedEthincityreset,
      selectedGradereset.columnValue.length && selectedGradereset,
      selectedschoolnamereset.columnValue.length && selectedschoolnamereset,
    ]
    //  console.log("jjjjjjjjj",j)
    return j.filter(val => val !== 0);
  }

  const removeNullFunGrad1 = () => {
    let j = [
      selectedMeasure.columnValue.length && selectedMeasure,
      selectedSchoolType.columnValue.length && selectedSchoolType,
      selectedYearreset.columnValue.length && selectedYearreset,
      selectedSchoolreset.columnValue.length && selectedSchoolreset,
      selectedGenderreset.columnValue.length && selectedGenderreset,
      selectedEthincityreset.columnValue.length && selectedEthincityreset,
      selectedGradereset.columnValue.length && selectedGradereset,
      selectedschoolnamereset.columnValue.length && selectedschoolnamereset,
    ]
    console.log("jjjjjjjjj", j)
    return j.filter(val => val !== 0);
  }
  // ---------------------------------------------------------------------------------------------------------
  const [selectedMeasure, setSelectedMeasure] = useState({
    "columnName": "MEASURE_TYPE",
    "columnValue": ["All"],
    "excludeKeyword": false
  })
  const [selectedSchoolType, setSelectedSchoolType] = useState({
    "columnName": "SCHOOL_OFFICIAL_NAME",
    "columnValue": ["DistrictWide"],
    "excludeKeyword": false
  })
  const [selectedYear, setSelectedYear] = useState({
    "columnName": "SCHOOL_YEAR",
    "columnValue": [],
    "excludeKeyword": false
  })
  const [selectedSchool, setSelectedSchool] = useState({
    "columnName": "SCHOOL_TYPE",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGender, setSelectedGender] = useState({
    "columnName": "STUDENT_GENDER",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedEthincity, setSelectedEthincity] = useState({
    "columnName": "STUDENT_ETHNICITY",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGrade, setSelectedGrade] = useState({
    "columnName": "STUDENT_GRADE",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedschoolname, setSelectedschoolname] = useState({
    "columnName": "SCHOOL_OFFICIAL_NAME",
    "columnValue": [],
    "excludeKeyword": false
  })
  // ---------------------------------------------------------------------------------------------
  const [selectedYearFilter, setSelectedYearFilter] = useState({
    "columnName": "SCHOOL_YEAR",
    "columnValue": [],
    "excludeKeyword": false
  })
  const [selectedSchoolFilter, setSelectedSchoolFilter] = useState({
    "columnName": "SCHOOL_TYPE",
    "columnValue": [],
    "excludeKeyword": false
  })
  const [selectedGenderFilter, setSelectedGenderFilter] = useState({
    "columnName": "GENDER",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedEthincityFilter, setSelectedEthincityFilter] = useState({
    "columnName": "ETHNICITY",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedGradeFilter, setSelectedGradeFilter] = useState({
    "columnName": "GRADE",
    "columnValue": [],
    "excludeKeyword": false
  })

  const [selectedschoolnameFilter, setSelectedschoolnameFilter] = useState({
    "columnName": "SCHOOL_NAME",
    "columnValue": [],
    "excludeKeyword": false
  })

  // useEffect(()=>{
  //     dispatch(fetchMenu_School_Year({
  //       "elasticQueryName": "Menu_School_Year",
  //       "filters": [],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_School_Level({
  //       "elasticQueryName": "Menu_School_Level",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       },
  //     ],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_School_Name({
  //       "elasticQueryName": "Menu_School_Name",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       }],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_Gender({
  //       "elasticQueryName": "Menu_Gender",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       }],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_Grade({
  //       "elasticQueryName": "Menu_Grade",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       }],
  //       "dynamicColumns": [],
  //     }));

  //     dispatch(fetchMenu_Ethnicity({
  //       "elasticQueryName": "Menu_Ethnicity",
  //       "filters": [{
  //         "columnName": "SCHOOL_YEAR",
  //         "columnValue": ["2022"],
  //         "excludeKeyword": false
  //       }],
  //       "dynamicColumns": [],
  //     }));
  //   },[])

  useEffect(() => {
    const handleBeforeUnload = () => {
      window.sessionStorage.removeItem('SchoolType');
      window.sessionStorage.removeItem('Year');
      window.sessionStorage.removeItem('Gender');
      window.sessionStorage.removeItem('Ethincity');
      window.sessionStorage.removeItem('Grade');
      window.sessionStorage.removeItem('enrollmentdimension');
      window.sessionStorage.removeItem('allfilter');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  let SchoolType = JSON.parse(sessionStorage.getItem("SchoolType"))
  let Year = JSON.parse(sessionStorage.getItem("Year"))
  let Gender = JSON.parse(sessionStorage.getItem("Gender"))
  let Ethincity = JSON.parse(sessionStorage.getItem("Ethincity"))
  let Grade = JSON.parse(sessionStorage.getItem("Grade"))
  let Schoolname = JSON.parse(sessionStorage.getItem("Schoolname"))

  const [selectedYeardata, setSelectedYeardata] = useState(Year ? Year : pagename == '/statebenchmarking' ? "2024" : "2025")
  console.log('selectedYeardata: ', selectedYeardata);
  sessionStorage.setItem("Year", JSON.stringify(selectedYeardata));

  const [selectedSchooldata, setSelectedSchooldata] = useState(SchoolType ? SchoolType : [])
  sessionStorage.setItem("SchoolType", JSON.stringify(selectedSchooldata));

  const [selectedGenderdata, setSelectedGenderdata] = useState(Gender ? Gender : [])
  sessionStorage.setItem("Gender", JSON.stringify(selectedGenderdata));

  const [selectedEthincitydata, setSelectedEthincitydata] = useState(Ethincity ? Ethincity : [])
  sessionStorage.setItem("Ethincity", JSON.stringify(selectedEthincitydata));

  const [selectedGradedata, setSelectedGradedata] = useState(Grade ? Grade : [])
  sessionStorage.setItem("Grade", JSON.stringify(selectedGradedata));

  const [selectedSchoolnamedata, setSelectedSchoolnamedata] = useState(Schoolname ? Schoolname : [])
  sessionStorage.setItem("Schoolname", JSON.stringify(selectedSchoolnamedata));

  useEffect(() => {
    setselectedMenu_School_Year(Menu_School_Yeardata)
    let selectedArray = []
    // selectedYeardata?.map((k) => {
    //   selectedArray.push(k.value)
    // })
    setSelectedYear({
      "columnName": "SCHOOL_YEAR",
      "columnValue": selectedYeardata,
      "excludeKeyword": false
    });
    setSelectedYearFilter({
      "columnName": "SCHOOL_YEAR",
      "columnValue": selectedYeardata,
      "excludeKeyword": false
    });
  }, [selectedYeardata, Menu_School_Yeardata.length]);

  useEffect(() => {
    setSelectedMenu_School_Level(Menu_School_Leveldata)
    let selectedArray = []
    selectedSchooldata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedSchool({
      "columnName": "SCHOOL_TYPE",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });

    setSelectedSchoolFilter({
      "columnName": "SCHOOL_TYPE",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedSchooldata, Menu_School_Leveldata.length]);

  useEffect(() => {
    setSelectedMenu_Gender(Menu_Gender)
    let selectedArray = []
    selectedGenderdata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedGender({
      "columnName": "STUDENT_GENDER",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
    setSelectedGenderFilter({
      "columnName": "GENDER",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedGenderdata, Menu_Gender.length]);

  useEffect(() => {
    setSelectedMenu_Ethnicity(Menu_Ethnicity)
    let selectedArray = []
    selectedEthincitydata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedEthincity({
      "columnName": "STUDENT_ETHNICITY",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
    setSelectedEthincityFilter({
      "columnName": "ETHNICITY",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedEthincitydata, Menu_Ethnicity.length]);

  useEffect(() => {
    setSelectedMenu_Grade(Menu_Grade)
    let selectedArray = []
    selectedGradedata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedGrade({
      "columnName": "STUDENT_GRADE",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
    setSelectedGradeFilter({
      "columnName": "GRADE",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedGradedata, Menu_Grade.length]);

  useEffect(() => {
    setSelectedMenu_School_Name(Menu_School_Namedata)
    let selectedArray = []
    selectedSchoolnamedata?.map((k) => {
      selectedArray.push(k.value)
    })
    setSelectedschoolname({
      "columnName": "SCHOOL_OFFICIAL_NAME",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });

    setSelectedschoolnameFilter({
      "columnName": "SCHOOL_NAME",
      "columnValue": selectedArray,
      "excludeKeyword": false
    });
  }, [selectedSchoolnamedata, Menu_School_Namedata?.length]);


  const applyFilterFunc = () => {

    const body = {
      "elasticQueryName": "",
      "filters":
        removeNullFun()
      ,
      "grad_filters": removeNullFunGrad(),
      "dynamicColumns": [],
    };
    handleChange(body)
  }

  useEffect(() => {
    const bodyFilter = {
      "elasticQueryName": "",
      "filters":
        removeNullFunFilter()
      ,
      "dynamicColumns": [],
    };
    handleChangeFilter(bodyFilter)
  }, [selectedYearFilter, selectedSchoolFilter, selectedGenderFilter, selectedEthincityFilter, selectedGradeFilter, selectedschoolnameFilter]);

  const removeNullFunFilter = () => {
    let j = [
      selectedYearFilter.columnValue.length && selectedYearFilter,
      selectedSchoolFilter.columnValue.length && selectedSchoolFilter,
      selectedGenderFilter.columnValue.length && selectedGenderFilter,
      selectedEthincityFilter.columnValue.length && selectedEthincityFilter,
      selectedGradeFilter.columnValue.length && selectedGradeFilter,
      selectedschoolnameFilter.columnValue.length && selectedschoolnameFilter,
    ]
    console.log('.filter(val => val !== 0): ', j.filter(val => val !== 0));
    return j.filter(val => val !== 0);
  }
  let enrollmentdimension = sessionStorage.getItem("enrollmentdimension")
  let selectedoptions = sessionStorage.getItem("selectedoptions")
  let selectedoptions1 = sessionStorage.getItem("selectedoptions1")
  let selectedoptions2 = sessionStorage.getItem("selectedoptions2")
  let selectedoptions3 = sessionStorage.getItem("selectedoptions3")
  let selectedmetric = sessionStorage.getItem("selectedmetric")


  let performancesummary = sessionStorage.getItem("performancesummary")

  function removeGradFilter(data) {
    // Filter out the object with the specified columnName from grad_filters
    data.grad_filters = data.grad_filters.filter(f => f.columnName !== "SCHOOL_OFFICIAL_NAME");
    return data;
  }
  const handleChange = (body) => {
    // debugger
    var Yearremove = body;
    Yearremove = Yearremove?.filters?.filter((item) => item.columnName != "SCHOOL_YEAR");
    var data1 = {
      "elasticQueryName": "",
      "filters": Yearremove,
      "dynamicColumns": [],
    }
    var dataenrollmentdimension = {
      "elasticQueryName": "",
      "filters": body?.filters,
      "dynamicColumns": [{ columnName: "#{dimension}", columnValue: [enrollmentdimension] }],
    }
    var filtereddata = body?.filters.concat([{ "columnName": "METRIC_ID", "columnValue": [Number(selectedmetric)] }])
    // console.log("filtereddata",filtereddata)
    var datasankey = {
      "elasticQueryName": "",
      "filters": filtereddata,
      "dynamicColumns": [{ columnName: "#{dimension_1}", columnValue: [selectedoptions], "excludeKeyword": false },
      { columnName: "#{dimension_2}", columnValue: [selectedoptions1] },
      { columnName: "#{dimension_3}", columnValue: [selectedoptions2] },
      { columnName: "#{dimension_4}", columnValue: [selectedoptions3] },
      ],
    }

    var filtereddatastudent = body?.filters.concat([{ "columnName": "METRIC_ID", "columnValue": [Number(selectedmetric)], "excludeKeyword": false }])
    var filtereddatastudentSTB = filtereddatastudent.filter((item) => item.columnName == "SCHOOL_YEAR")
    console.log('filtereddatastudentbody: ', filtereddatastudentSTB);
    var datastudent = {
      "elasticQueryName": "",
      "filters": filtereddatastudent,
      "dynamicColumns": [{ columnName: "#{dimension}", columnValue: [performancesummary], "excludeKeyword": false },
      ],
    }
    var STBstudent = {
      "elasticQueryName": "",
      "filters": filtereddatastudentSTB,
      "dynamicColumns": [
      ],
    }
    sessionStorage.setItem("allfilter", JSON.stringify(body));
    if (pagename == '/') {
      dispatch(fetchAt_A_Glance_Top_Tile(body));
      dispatch(fetchStudent_Enrollment_Report(removeGradFilter(body)));
      dispatch(fetchStudent_Characteristics(removeGradFilter(body)));
      dispatch(fetchStudent_Group(removeGradFilter(body)));
      dispatch(fetchStudent_Enrollment_By_Year(data1));
      dispatch(fetchStudent_Enrollment_By_Grade(removeGradFilter(body)));
      dispatch(fetchSchool_And_Centers(removeGradFilter(body)));
      dispatch(fetchSchools_Centers_Report(removeGradFilter(body)));
      dispatch(fetchTotalTeacherFTE(body))
      dispatch(fetchTeacherFTE(body))
      dispatch(fetchStudentCounselorRatio(body))
      dispatch(fetchStudentTeacherRatio(body))
    } else if (pagename == '/enrollment') {
      dispatch(fetchEnrollment(removeGradFilter(body)));
      dispatch(fetchSpecial_Group(removeGradFilter(body)));
      dispatch(fetchEthnicity_Mix(removeGradFilter(body)));
      dispatch(fetchSPED_Enrollment(removeGradFilter(body)));
      dispatch(fetchNet_Movement(removeGradFilter(body)));
      dispatch(fetchGraduation_To_KG_Enrollment_Ratio(removeGradFilter(body)));
      dispatch(fetchInter_School_Conversion(removeGradFilter(body)));
      dispatch(fetchSchools_Biggest_Gainers(removeGradFilter(body)));
      dispatch(fetchSchools_Biggest_Losers(removeGradFilter(body)));
      dispatch(fetchTime_Analysis(data1));
      dispatch(fetchEnrollment_Time_Analysis(removeGradFilter(body)));
      dispatch(fetchEnrollment_Summary_By_Dimensions(dataenrollmentdimension));
    } else if (pagename == '/studentbehavior') {
      dispatch(fetchDistrict_Climate_Rating(removeGradFilter(body)));
      dispatch(fetchstudent_behavior_poor_performing_schools(removeGradFilter(body)));
      dispatch(fetchstudent_behavior_top_performing_schools(removeGradFilter(body)));
      dispatch(fetchStudent_Behavior_Incident_Type(removeGradFilter(body)));
      dispatch(fetchStudent_Behavior_Chart(data1));
    } else if (pagename == '/StrengthWeakness') {
      dispatch(fetchImprovement_Tile_Report(body));
      dispatch(fetchStrength_Tile_Report(body));
      dispatch(fetchWeakness_Tile_Report(body));
      dispatch(fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART(datasankey));
      dispatch(fetchSTRENGTH_AND_WEAKNESS_DRILL_DOWN_CHART_GRADUATION(datasankey));
    } else if (pagename == '/StudentPerformance') {
      console.log('datastudent: ', datastudent);
      dispatch(fetchstudent_performance_tile_report(body));
      dispatch(fetchstudent_dimension_table_report(datastudent));
      dispatch(fetchstudent_dimension_report(datastudent));
      dispatch(fetchstudent_dimension_table_report_graduation(datastudent));
      dispatch(fetchstudent_dimension_report_graduation(datastudent));
    } else if (pagename == '/schoolperformance') {
      dispatch(fetchSchool_Performance_School_Type_Report(removeGradFilter(body)));
      dispatch(fetchSchool_Performance_Metric_Report(removeGradFilter(body)));
      dispatch(fetchSchool_Performance_Map_Report(removeGradFilter(body)));
      dispatch(fetchSchool_Performance_Pie_Chart_Report(removeGradFilter(body)));
    } else if (pagename == '/statebenchmarking') {

      dispatch(fetchDistrict_Size(STBstudent));
      dispatch(fetchNearby_District(STBstudent));
      dispatch(fetchDemographic(STBstudent));
      dispatch(fetchFunding(STBstudent));
      dispatch(fetchCost_Per_Student(STBstudent));
    }
  }

  const removeNullFun = () => {
    let j = [
      selectedYear.columnValue.length && selectedYear,
      selectedSchool.columnValue.length && selectedSchool,
      selectedGender.columnValue.length && selectedGender,
      selectedEthincity.columnValue.length && selectedEthincity,
      selectedGrade.columnValue.length && selectedGrade,
      selectedschoolname.columnValue.length && selectedschoolname,
    ]
    return j.filter(val => val !== 0);
  }

  const removeNullFunGrad = () => {
    let j = [
      selectedGender.columnValue.length == 0 && selectedEthincity.columnValue.length == 0 && selectedMeasure.columnValue.length && selectedMeasure,
      selectedGender.columnValue.length == 0 && selectedEthincity.columnValue.length == 0 && selectedSchoolType.columnValue.length && selectedSchoolType,
      selectedYear.columnValue.length && selectedYear,
      selectedSchool.columnValue.length && selectedSchool,
      selectedGender.columnValue.length == 0 && selectedEthincity.columnValue.length && selectedEthincity,
      selectedGender.columnValue.length && selectedGender,
      selectedschoolname.columnValue.length && selectedschoolname,
    ]
    console.log('jjjjjjjjkkkkkkk: ', j);
    return j.filter(val => val !== 0 && val !== false);
  }


  const handleChangeFilter = (body) => {
    var Yearremove = body;
    var removeschoollevel = body;
    var removeschoolname = body;
    var removegrade = body;
    var removegender = body;
    var removeethnicity = body;
    Yearremove = Yearremove?.filters?.filter((item) => item.columnName != "SCHOOL_YEAR");
    var data1 = {
      "elasticQueryName": "",
      "filters": Yearremove,
      "dynamicColumns": [],
    }
    removeschoollevel = removeschoollevel?.filters?.filter((item) => item.columnName != "SCHOOL_TYPE" && item.columnName != "SCHOOL_NAME"
      && item.columnName != "GRADE" && item.columnName != "GENDER" && item.columnName != "ETHNICITY"
    );
    var dataremoveschoollevel = {
      "elasticQueryName": "",
      "filters": removeschoollevel,
      "dynamicColumns": [],
    }
    removeschoolname = removeschoolname?.filters?.filter((item) => item.columnName != "SCHOOL_NAME");
    var dataremoveschoolname = {
      "elasticQueryName": "",
      "filters": removeschoolname,
      "dynamicColumns": [],
    }
    removegrade = removegrade?.filters?.filter((item) => item.columnName != "GRADE");
    var dataremovegrade = {
      "elasticQueryName": "",
      "filters": removegrade,
      "dynamicColumns": [],
    }
    removegender = removegender?.filters?.filter((item) => item.columnName != "GENDER");
    var dataremovegender = {
      "elasticQueryName": "",
      "filters": removegender,
      "dynamicColumns": [],
    }
    removeethnicity = removeethnicity?.filters?.filter((item) => item.columnName != "ETHNICITY");
    var dataremoveethnicity = {
      "elasticQueryName": "",
      "filters": removeethnicity,
      "dynamicColumns": [],
    }
    dispatch(fetchMenu_School_Year(data1));
    dispatch(fetchMenu_School_Level(dataremoveschoollevel));
    dispatch(fetchMenu_School_Name(dataremoveschoolname));
    dispatch(fetchMenu_Gender(dataremovegender));
    dispatch(fetchMenu_Grade(dataremovegrade));
    dispatch(fetchMenu_Ethnicity(dataremoveethnicity));
  }


  return (
    <div >
      <div className='p-10'>

        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">School Year</label>
          {/* <MultiSelect
                         options={yearOptions}
                        value={selectedYeardata}
                         onChange={setSelectedYeardata}
                         overrideStrings={{
                           allItemsAreSelected: "All",
                         }}
                        labelledBy="Type to Search or Select"
                    /> */}
          <Dropdown value={selectedYeardata} onChange={(e) => setSelectedYeardata(e.value)} options={yearOptions} optionLabel="name"
            placeholder={selectedYeardata} className="w-full md:w-14rem text-xs" style={{ width: 193 }} />

        </form>
        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">School Type</label>
          <MultiSelect
            options={schoolTypeOptions}
            value={selectedSchooldata}
            onChange={setSelectedSchooldata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>

        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">School Name</label>
          <MultiSelect
            options={schoolnameOption}
            value={selectedSchoolnamedata}
            onChange={setSelectedSchoolnamedata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>

        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">Grade</label>
          <MultiSelect
            options={gradeOptions}
            value={selectedGradedata}
            onChange={setSelectedGradedata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>
        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">Ethnicity</label>
          <MultiSelect
            options={ethinOption}
            value={selectedEthincitydata}
            onChange={setSelectedEthincitydata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>
        <form className="form-floating my-2 px-1" style={{ width: 200 }}>
          <label className="filterTitle">Gender</label>
          <MultiSelect
            options={genderOptions}
            value={selectedGenderdata}
            onChange={setSelectedGenderdata}
            overrideStrings={{
              allItemsAreSelected: "All",
            }}
            labelledBy="Type to Search or Select"
          />

        </form>


        <button className='filterBut py-2 px-1' style={{ position: "relative", left: "20px" }} onClick={applyFilterFunc}>Apply</button>
        <button className='filterBut py-2 px-1' style={{ position: "relative", left: "20px" }} onClick={resetFilterFunc}>Reset</button>
      </div>
    </div>
  )
}

export default FilterComponent
